import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';

type PaginatedHiddenProjects = {
  time: number;
  count: number;
  results: any[];
};

type HiddenProjectIdsResponse = {
  data: string[];
  message: string;
};

const getPaginatedHiddenProjects = (
  page: number = 1,
  sort: string[] = [],
): Promise<AxiosResponse<PaginatedHiddenProjects | null>> => {
  return api.post(`/hidden-projects/list/?page=${page}`, { sort });
};

const postHideProject = ({
  projectSlug,
  documentId,
}: {
  projectSlug?: string;
  documentId?: string;
}): Promise<AxiosResponse> => {
  return api.post('/hidden-projects/', {
    project_slug: projectSlug,
    document_id: documentId,
  });
};

const getHiddenProjectIds = (): Promise<
  AxiosResponse<HiddenProjectIdsResponse | null>
> => {
  return api.get('/hidden-projects/ids/');
};

const deleteHiddenProject = (slug: string): Promise<AxiosResponse> => {
  return api.delete(`/hidden-projects/${slug}/`);
};

export default {
  getPaginatedHiddenProjects,
  postHideProject,
  getHiddenProjectIds,
  deleteHiddenProject,
};
